import PropTypes from 'prop-types';
import Link from 'next/link';
import Image from 'next/image';
import DateFormatter from 'components/DateFormatter';

const HeroPost = ({
  id,
  slug,
  featuredImage,
  categories,
  title,
  author,
  date,
}) => (
  <div
    key={id}
    className="col-span-2 flex flex-col overflow-hidden rounded-lg shadow-md"
  >
    <div className="flex-shrink-0">
      <a href={`/blog/${slug}/`}>
        <div className="relative w-full leading-0">
          <Image
            src={featuredImage?.node?.sourceUrl}
            objectFit="cover"
            alt={title}
            width={804}
            height={804 / 2}
            priority
          />
        </div>
      </a>
    </div>
    <div className="flex flex-1 flex-col justify-between bg-white p-6">
      <div className="flex-1">
        {categories && (
          <p className="text-sm font-medium text-blue-08">
            {categories.edges.map(({ node }, i, arr) => (
              <span key={node.id}>
                <Link href={`/category/${node.slug}`} passHref>
                  <a className="hover:underline">{node.name}</a>
                </Link>
                {arr.length - 1 === i ? '\u00A0' : <>, </>}
              </span>
            ))}
          </p>
        )}
        <a className="mt-2 block" href={`/blog/${slug}/`}>
          <p className="text-xl font-semibold text-grey-10">{title}</p>
        </a>
      </div>
      <div className="mt-4 flex items-center">
        <div className="flex-shrink-0">
          <span className="sr-only">{author.node.name}</span>
          <div className="relative h-10 w-10">
            <Image
              className="rounded-full"
              src={author.node.avatar.url}
              layout="fill"
            />
          </div>
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-grey-10">{author.node.name}</p>
          <div className="flex space-x-1 text-sm text-grey-08">
            <DateFormatter dateString={date} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

HeroPost.propTypes = {
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  featuredImage: PropTypes.shape({
    node: PropTypes.shape({
      sourceUrl: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  categories: PropTypes.shape([]),
  title: PropTypes.string.isRequired,
  author: PropTypes.shape({
    node: PropTypes.shape({
      name: PropTypes.string.isRequired,
      avatar: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  date: PropTypes.string.isRequired,
};

HeroPost.defaultProps = {
  categories: null,
};

export default HeroPost;
